import LabService from "./LabService";
import UnitService from "./UnitService";
import DoctorService from "./DoctorService";

export default function Controller(props) {
  const { related_to } = props.plan;
  switch (related_to) {
    case "lab":
      return <LabService {...props} />;
    case "unit":
      return <UnitService {...props} />;
    default:
      return <DoctorService {...props} />;
  }
}
